import { createFileRoute } from "@tanstack/react-router";
import { MarketingHero } from "@/components/marketing-hero";
import { MarketingPageShell } from "@/components/marketing-page-shell";
import { HomepageAgentInstall } from "@/components/setup/homepage-agent-install";
import { buildPageHead } from "@/lib/seo-meta";

const path = "/openclaw-social-media";

export const Route = createFileRoute(path)({
	component: OpenClawSocialMedia,
	head: ({ matches }) =>
		buildPageHead({
			matches,
			internalPath: path,
			title: "Boost your Social Media using OpenClaw",
			description:
				"Plug OpenClaw into AgentReacher's MCP server and let your open-source agent draft, schedule, and ship posts across every social network.",
		}),
});

function OpenClawSocialMedia() {
	return (
		<MarketingPageShell>
			<MarketingHero
				agent="openclaw"
				title="Boost your Social Media using OpenClaw"
				description="AgentReacher exposes a hosted MCP server OpenClaw can call. Draft, schedule, and publish to every social platform without leaving your agent loop."
				primaryCta={{ label: "Connect OpenClaw", to: "/signup" }}
				secondaryCta={{ label: "Setup docs", to: "/docs/mcp" }}
			/>

			<HomepageAgentInstall />
		</MarketingPageShell>
	);
}
